"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var prism_icons_1 = require("@octanner/prism-icons");
var IconButton_1 = __importDefault(require("../IconButton"));
var ClampText_1 = __importDefault(require("./ClampText"));
var colors_1 = require("../ThemeProvider/colors");
var Alert = function (_a) {
    var action = _a.action, onClose = _a.onClose, _b = _a.variant, variant = _b === void 0 ? 'standard' : _b, children = _a.children, _c = _a.severity, severity = _c === void 0 ? 'info' : _c, _d = _a.maxLines, maxLines = _d === void 0 ? 3 : _d, props = __rest(_a, ["action", "onClose", "variant", "children", "severity", "maxLines"]);
    var secondaryStyles = severity === 'secondary'
        ? {
            backgroundColor: colors_1.tannerGray['100'],
            color: colors_1.tannerGray['700'],
            '.MuiButton-text': {
                color: colors_1.tannerGray['800'],
                '&:hover': {
                    color: colors_1.tannerGray['800'],
                    backgroundColor: colors_1.tannerGray['300'],
                },
            },
            ' .MuiIconButton-root': {
                color: colors_1.tannerGray['700'],
                '&:hover,&:active': {
                    color: colors_1.tannerGray['800'],
                    backgroundColor: colors_1.tannerGray['300'],
                },
            },
        }
        : {};
    return (react_1.default.createElement(Alert_1.default, __assign({}, props, { sx: variant === 'vertical'
            ? __assign({ display: 'flex', padding: '8px 16px', '& .MuiAlert-message': {
                    padding: '4px 0px',
                }, alignItems: 'baseline' }, secondaryStyles) : secondaryStyles, variant: "standard", severity: severity === 'secondary' ? 'info' : severity, action: react_1.default.createElement(react_1.default.Fragment, null,
            action,
            onClose && (react_1.default.createElement(IconButton_1.default, { size: "small", sx: __assign({ marginLeft: '8px' }, (severity === 'secondary' && {
                    '&.MuiIconButton-sizeSmall': {
                        color: colors_1.tannerGray[600],
                        '&:hover': {
                            backgroundColor: colors_1.tannerGray[200],
                        },
                    },
                })), onClick: onClose, "aria-label": "close", color: severity },
                react_1.default.createElement(prism_icons_1.Close, null)))) }), variant === 'vertical' ? (react_1.default.createElement(ClampText_1.default, { severity: severity, text: children, maxLines: maxLines })) : (children)));
};
exports.default = Alert;
__exportStar(require("@mui/material/Alert"), exports);
//# sourceMappingURL=index.js.map